import { Pipe, PipeTransform } from '@angular/core';

const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

/** Formats a number as USD with no decimals, e.g. $193,300. */
@Pipe({ name: 'uwMoney', standalone: true })
export class UwMoneyPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined || Number.isNaN(value)) return '—';
    return money.format(value);
  }
}

/** Formats a number as a compact currency, e.g. $18.4M. */
@Pipe({ name: 'uwCompactMoney', standalone: true })
export class UwCompactMoneyPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined || Number.isNaN(value)) return '—';
    if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
    if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
    return `$${Math.round(value)}`;
  }
}

/** Formats a ratio as a percentage string, e.g. 0.31 -> 31%. */
@Pipe({ name: 'uwPercent', standalone: true })
export class UwPercentPipe implements PipeTransform {
  transform(value: number | null | undefined, fractionDigits = 0): string {
    if (value === null || value === undefined || Number.isNaN(value)) return '—';
    return `${value.toFixed(fractionDigits)}%`;
  }
}

/** Derives initials from a name, e.g. "Ferris Bros. Construction" -> "FB". */
@Pipe({ name: 'uwInitials', standalone: true })
export class UwInitialsPipe implements PipeTransform {
  transform(name: string | null | undefined): string {
    if (!name) return '—';
    return name
      .split(/\s+/)
      .map((w) => w[0])
      .filter((c) => c && /[A-Za-z0-9]/.test(c))
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }
}
